import React from "react";
import { View, StyleSheet } from "react-native";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import NtSectionTitle from "../general/NtSectionTitle";

function NtAboutSection(props) {
  return (
    <NtMarketingSectionContainer
      style={styles.container}
      backgroundImage={require("../../../assets/images/marketing/ff8be5d5b3ab6249a5739ba42b1b268c10d1acda.png")}
    >
      <NtSectionTitle style={{ marginTop: 150, fontSize: 28 }}>
        ABOUT US
      </NtSectionTitle>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    height: 300,
  },
});

export default NtAboutSection;
